import script from "./ConfiguracaoImagemItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfiguracaoImagemItem.vue?vue&type=script&setup=true&lang=js"

import "./ConfiguracaoImagemItem.vue?vue&type=style&index=0&id=62a52395&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62a52395"]])

export default __exports__